export const siteInfo = {
  name: '福利导航在线观看',
  tagline: '精选资源一站式导航',
  description: '福利导航在线观看，汇聚全网精选优质资源，提供便捷一站式导航服务。无需下载，直接在线观看，内容分类清晰，更新及时，让您快速找到所需内容，畅享流畅在线体验。',
  keywords: '福利导航在线观看,在线观看导航,福利资源导航,免费在线观看,视频导航网站,精选资源在线,一站式导航观看',
  url: 'https://www.fulidaohang.com',
  email: 'contact@fulidaohang.com',
  foundingYear: '2020',
  stats: {
    totalResources: '10000+',
    dailyVisitors: '50万+',
    categories: '8',
    satisfaction: '98%',
  },
  features: [
    {
      title: '资源丰富',
      description: '汇聚全网精选优质资源，涵盖影视、综艺、动漫、纪录片等多个类别',
      icon: 'ri-database-2-line',
    },
    {
      title: '免费使用',
      description: '所有导航服务完全免费，无需注册即可使用，让您畅享流畅体验',
      icon: 'ri-vip-crown-line',
    },
    {
      title: '更新及时',
      description: '内容团队每日更新，确保资源库始终与全网同步，不错过任何精彩',
      icon: 'ri-refresh-line',
    },
    {
      title: '分类清晰',
      description: '科学的内容分类体系，让您快速找到所需的优质资源',
      icon: 'ri-layout-grid-line',
    },
  ],
  contactInfo: {
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    phone: '400-888-9999',
    email: 'contact@fulidaohang.com',
    wechat: 'fulidaohang2024',
    workingHours: '周一至周五 9:00 - 18:00',
  },
  brandStory: `福利导航在线观看成立于2020年，是专注于在线资源导航服务的平台。创始团队由一群热爱互联网、热衷于分享优质资源的年轻人组成。我们深知在海量信息中找到优质内容的困难，因此致力于打造一个简洁、高效、可靠的资源导航平台。

经过多年的发展，福利导航在线观看已经成为国内知名的资源导航网站之一，每天为数以万计的用户提供便捷的导航服务。我们始终坚持"用户至上、内容为王"的理念，不断优化产品体验，拓展资源库，努力成为用户在线娱乐生活的首选入口。

未来，我们将继续深耕资源导航领域，引入更多优质内容，提升技术能力，为用户提供更加智能、个性化的导航体验。`,
  reputationHighlights: [
    { title: '用户满意度', value: '98%', description: '来自百万用户的真实反馈' },
    { title: '日均访问量', value: '50万+', description: '稳定增长的活跃用户群体' },
    { title: '资源总量', value: '10000+', description: '持续扩充的优质资源库' },
    { title: '服务年限', value: '4年+', description: '长期稳定的运营服务' },
  ],
};